module.exports = __webpack_public_path__ + "53344cda5013dd6d27cda2fbf26a2f29.png";